import { createContext, useContext, useEffect, useState } from 'react'

type VideoScaleContextType = {
  videoScale: number
  videoWidth: number
}

export const VideoScaleContext = createContext<VideoScaleContextType>({
  videoScale: 1.0,
  videoWidth: 0,
})

export const useVideoScale = () => {
  const context = useContext(VideoScaleContext)

  return context
}

const BaseWidth = 1440

export const VideoScaleProvider = ({
  children,
  video,
}: {
  children: React.ReactNode
  video: HTMLVideoElement
}) => {
  const [videoScale, setVideoScale] = useState(
    Math.max(Math.min(video.offsetWidth / BaseWidth, 1.0), 0.4),
  )
  const [videoWidth, setVideoWidth] = useState(video.offsetWidth)

  useEffect(() => {
    const updateScale = () => {
      const w = video.offsetWidth
      setVideoWidth(w)
      setVideoScale(Math.max(Math.min(w / BaseWidth, 1.0), 0.4))
    }

    updateScale()

    const resizeObserver = new ResizeObserver(() => {
      updateScale()
    })

    resizeObserver.observe(video)

    return () => {
      resizeObserver.disconnect()
    }
  }, [video])

  return <VideoScaleContext.Provider value={{ videoScale, videoWidth }}>{children}</VideoScaleContext.Provider>
}
